import type { TriggerMetisOcppLogsResponseDto } from '@evimo/types';
import { SIGEIF_ORGANIZATION_ID } from '~/app/constants/sigeif-organization';
import { buildApiUrl } from '~/app/lib/api-config';

export const METIS_OCPP_LOGS_TRIGGER_ORGANIZATION_ID = SIGEIF_ORGANIZATION_ID;

export async function triggerMetisOcppLogs(
  organizationId: string = METIS_OCPP_LOGS_TRIGGER_ORGANIZATION_ID,
): Promise<TriggerMetisOcppLogsResponseDto> {
  const response = await fetch(buildApiUrl('/api/v1/metis/ocpp-logs/trigger'), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ organizationId }),
  });

  if (!response.ok) {
    const payload = (await response.json().catch(() => null)) as {
      message?: string | string[];
    } | null;

    const message = Array.isArray(payload?.message)
      ? payload.message.join('; ')
      : payload?.message;

    throw new Error(message ?? 'Failed to trigger Metis OCPP logs.');
  }

  return (await response.json()) as TriggerMetisOcppLogsResponseDto;
}
